export const segments = [
  {
    id: "insurance",
    label: "Insurance",
    href: "/for-insurance",
    kicker: "01 — Insurance",
    lead:
      "A meaningful healthcare benefit within the customer relationship.",
    body:
      "For insurers, Medicual can place a licensed clinical pathway inside the customer proposition, giving customers a clear digital entry point before care begins.",
  },
  {
    id: "banking",
    label: "Banking",
    href: "/for-banking",
    kicker: "02 — Banking",
    lead:
      "A tangible benefit that adds everyday value beyond the core financial product.",
    body:
      "For banks, the pathway can add a concrete healthcare benefit alongside the core financial relationship.",
  },
  {
    id: "coops",
    label: "Co-ops & Associations",
    href: "/for-coops-and-associations",
    kicker: "03 — Co-ops & Associations",
    lead:
      "A healthcare pathway that can become part of the membership proposition.",
    body:
      "For co-operatives, associations and large member organisations, the pathway can become a clear healthcare benefit within the membership proposition.",
  },
];
